import React, { Component } from 'react';
import styled from 'styled-components';
import { Button, Toast } from '../../../common/components/atoms';
import { PopupMessage, POPUP_TYPE } from '../../common/PopupMessage';
import { ERROR_MESSAGE } from '../../common/constants.js'
import { unzip } from 'fflate';
import { ModalDialog } from '../../../common/components/molecues';
import { csvSplit } from '../../../common/helper/commonHelper.js'

class PhraseAddAllModal extends Component {
    constructor(props) {
        super(props);

        this.refZipFileInput = React.createRef();
        this.refToast = React.createRef();
        this.state = {
            id: 0,
            subjectID: 0,
            order: 0,
            zipFile: "",
            zipFileName: "",
            textEn: "",
            textJp: "",
            audioFileName: "",
            audioFileData: "",
            displayErrDlg: false,
            errType: 0,
            noFileErrs: [],
            noAudioErrs: [],
        }
    }

    set(phrase) {
        this.setState({
            id: phrase.id,
            subjectID: phrase.subjectID,
            order: phrase.order,
            audio: phrase.audio,
            textEn: phrase.textEn,
            textJp: phrase.textJp,
            check: phrase.check,
        });
    }

    setOrder(order) {
        this.setState({
            order: order,
        });
    }

    get() {
        return {
            id: this.state.id,
            subjectID: this.state.subjectID,
            order: this.state.order,
            audio: this.state.audio,
            textEn: this.state.textEn,
            textJp: this.state.textJp,
            check: this.state.check,
        }
    }

    clear(subjectID) {
        this.setState({
            id: "",
            subjectID: subjectID,
            audio: "",
            textEn: "",
            textJp: "",
            check: false,
        });
    }

    // 各単語・チャンクの値を取得する
    onChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        });
    }

    // 教材の一括登録ダイアログを出す
    onChangeFile = (e) => {
        this.setState({
            zipFileName: e.target.files[0].name,
            zipFile: e.target.files[0],
        });
        this.refZipFileInput.current.click();
        this.refZipFileInput.current.value = "";
    }

    // ファイル選択するためのエクスプローラーを開く
    onClickFileUpload = (e) => {
        this.refZipFileInput.current.click();
    }

    // zipファイルを解凍し、各カラムのデータを取得する
    onClickAddAll = async (e) => {
        let noFileErrs = [];
        let noAudioErrs = [];
        try {
            /**
             * zipファイルを解凍する
             */
            const zipFile = this.state.zipFile;
            if (!zipFile) {
                throw new Error('ZipFile is undefined.');
            }
            const buffer = await zipFile.arrayBuffer();
            const bufferData = await new Promise((resolve, reject) => {
                unzip(new Uint8Array(buffer), (err, bufferData) => {
                    if (err) {
                        reject(err);
                    } else {
                        resolve(bufferData);
                    }
                });
            });

            /**
             * 解凍したzipファイルのエントリを1つずつ取得し、存在チェック
             */
            let listFileLines = [];
            let audioFiles = [];
            let audioFolder;
            let listFile;
            // 文字化け文字コード定義
            const SINGLE_QUOTATION_MAC = String.fromCharCode(226,128,153);  // MacPCで圧縮した場合のファイル名の「’」の文字化け
            const SINGLE_QUOTATION_WIN = String.fromCharCode(129,102);      // WinPCで圧縮した場合のファイル名の「’」の文字化け
            // 文字化け置換 正規表現オブジェクト生成
            let regMac = new RegExp(SINGLE_QUOTATION_MAC, "g");
            let regWin = new RegExp(SINGLE_QUOTATION_WIN, "g");
            // zipファイルのエントリを1つずつ取得
            for (const [entryPath, entryData] of Object.entries(bufferData)) {
                // エラーチェック用の変数
                const fileBaseName = entryPath.replace(/^.*[\\/]/, ''); // ファイル名以前のパスを除外し、ファイル名のみを取得
                const audioFolderRegex = /audio\/$/; // audioフォルダの正規表現
                const audioFileRegex = /.+\/audio\/.*\.mp3$/; // 'audioフォルダ配下にあり、'.mp3'で終わるファイルの正規表現
                const targetFileName = "list.csv" // list.csvファイルの正規表現
                // 存在チェック
                if (audioFileRegex.test(entryPath)) { // 録音ファイルの存在チェック
                    let convertedPath = entryPath;
                    convertedPath = convertedPath.replace(regMac,'’'); // Mac文字化け「’」を置換
                    convertedPath = convertedPath.replace(regWin,'’'); // Win文字化け「’」を置換
                    audioFiles.push(new File([entryData.buffer], convertedPath, {type: "audio/mpeg"}));
                } else if (audioFolderRegex.test(entryPath)) { // audioフォルダの存在チェック
                    audioFolder = entryPath;
                } else if (fileBaseName === targetFileName) { // list.csvの存在チェック
                    listFile = entryPath;
                    // listファイルのデータを保存
                    let reader = new FileReader();
                    reader.readAsText(new File([entryData.buffer], entryPath, {type: "text/csv"}));
                    listFileLines = await new Promise((resolve, reject) => {
                        reader.onload = function(e) {
                            const text = e.target.result;
                            const lines = text
                                .split(/\r?\n/) // list.csvのデータを行ごとに分ける
                                .map(line => line.trim()) // 行の前後の空白を削除
                                .filter(line => line !== '') // 空白行は無視
                                .filter(line => !/英語,日本語,音声ファイル名/.test(line)); // ヘッダー行を無視
                            resolve(lines);
                        };
                        reader.onerror = function () {
                            reject(new Error('Failed to read list.csv'));
                        };
                    });
                }
            }

            /**
             * エラー内容に応じてエラーダイアログを表示
             */
            // エラーダイアログ：audioフォルダ、listファイル、どちらも存在しない場合
            if (!audioFolder && !listFile) {
                this.setState({
                    errType: ERROR_ADD_ALL.NO_FILE,
                });
                noFileErrs.push('audioフォルダ', 'list.csv');
                throw new Error('displayErrDlg');
            }
            // エラーダイアログ：audioフォルダが存在しない場合
            if (!audioFolder) {
                this.setState({
                    errType: ERROR_ADD_ALL.NO_FILE,
                });
                noFileErrs.push('audioフォルダ');
                throw new Error('displayErrDlg');
            }
            // エラーダイアログ：listファイルが存在しない場合
            if (!listFile) {
                this.setState({
                    errType: ERROR_ADD_ALL.NO_FILE,
                });
                noFileErrs.push('list.csv');
                throw new Error('displayErrDlg');
            }
            // エラーダイアログ：listファイルのデータが0件の場合
            if (listFileLines.length === 0) {
                this.setState({
                    errType: ERROR_ADD_ALL.ZERO_DATA,
                });
                throw new Error('displayErrDlg');
            }
            // エラーダイアログ：listファイルのデータが100件より多い場合
            if (listFileLines.length > 100) {
                this.setState({
                    errType: ERROR_ADD_ALL.OVER_DATA,
                });
                throw new Error('displayErrDlg');
            }

            /**
             * listファイルのデータを1行ずつ取得し、登録する
             */
            // listファイルのデータを1行ずつ取得
            for (let i = 0; i < Math.min(listFileLines.length, 100); i++) {
                const columns = csvSplit(listFileLines[i]); // カンマでカラムを分割
                const columnTextEn = columns[0].trim(); // カラム1のデータ
                const columnTextJp = columns[1].trim(); // カラム2のデータ
                const columnAudioName = columns[2].trim(); // カラム3のデータ
                // 各列のデータをセット
                this.setState({
                    textEn: columnTextEn,
                    textJp: columnTextJp,
                    order: this.state.order + 1,
                });
                // 対象のaudioファイルデータがあるかチェック
                const targetAudioFile = audioFiles.find(file => file.name.replace(/^.*[\\/]/, '') === columnAudioName)
                let audioFileData = null;
                let lastFlg = false;
                if (targetAudioFile) { // 対象のaudioFileが存在する場合、登録用にデータを保存
                    await new Promise((resolve) => {
                    let reader = new FileReader();
                    reader.readAsDataURL(targetAudioFile);
                        reader.onload = () => {
                            audioFileData = reader.result;
                            resolve();
                        };
                    });
                } else if (!targetAudioFile && columnAudioName) { // audio名はあるが対象のaudioFileが存在しない場合、注意ダイアログ用にデータを保存
                    noAudioErrs.push({
                        errTextEn: columnTextEn,
                        errAudioName: columnAudioName,
                    });
                }
                // 最後のデータの場合、エラーダイアログを表示するためのフラグをセット
                if (i === Math.min(listFileLines.length, 100) - 1) {
                    lastFlg = true;
                    if (noAudioErrs.length > 0) {
                        this.setState({
                            errType: ERROR_ADD_ALL.NO_AUDIO,
                            noAudioErrs: noAudioErrs,
                        });
                    }
                }
                // 一括登録を実施
                await this.savePhraseData(columnAudioName, audioFileData, lastFlg)
            }
        } catch (error) {
            if (error instanceof Error && error.message === 'displayErrDlg') {
                this.setState({
                    displayErrDlg: true,
                    noFileErrs: noFileErrs,
                });
            } else {
                this.onFailure();
            }
        }
    }

    // Sagaを使って教材をDBにデータ登録するイベント
    savePhraseData = (audioName, audioData, lastFlg) => {
        const noAudioErrs = this.state.noAudioErrs;
        let syserr = [];
        if (this.props.permission === 0) {
            syserr.push(ERROR_MESSAGE["permission_denied"]);
        }
        if (syserr.length === 0) {
            this.props.dispatch({
                type: "LoadStart"
            });
            if (this.props.editType === EDIT_TYPE.CHUNK) {
                this.props.dispatch({
                    type: "SetChunk_Saga",
                    chunk: {
                        id: this.state.id,
                        subjectID: this.state.subjectID,
                        textEn: this.state.textEn,
                        textJp: this.state.textJp,
                        check: this.state.check,
                        order: this.state.order,
                    },
                    onFailure: this.onFailure,
                    onSuccess: (response) => {
                        if (audioData) { // audioファイルがある場合、メソッドを呼び出す
                            this.saveAudioData(response, audioName, audioData, lastFlg);
                        } else if (audioData === null && lastFlg && noAudioErrs.length > 0) { // 最後の行：対象のaudioファイルが存在しない場合、エラーダイアログを出す
                            this.stopLoading();
                            this.setState({
                                displayErrDlg: true,
                            });
                        } else if (audioData === null && lastFlg && noAudioErrs.length === 0) { // 最後の行：audioファイル名がない場合、一括登録成功ダイアログを出す
                            this.onSuccess();
                        } else if (audioData === null && !lastFlg) { // 最後の行ではなく、audioファイルがない場合、スキップする
                            this.stopLoading();
                        }
                    },
                });
            } else {
                this.props.dispatch({
                    type: "SetVocabulary_Saga",
                    vocabulary: {
                        id: this.state.id,
                        subjectID: this.state.subjectID,
                        textEn: this.state.textEn,
                        textJp: this.state.textJp,
                        check: this.state.check,
                        order: this.state.order,
                    },
                    onFailure: this.onFailure,
                    onSuccess: (response) => {
                        if (audioData) { // audioファイルがある場合、メソッドを呼び出す
                            this.saveAudioData(response, audioName, audioData, lastFlg);
                        } else if (audioData === null && lastFlg && noAudioErrs.length > 0) { // 最後の行：対象のaudioファイルが存在しない場合、エラーダイアログを出す
                            this.stopLoading();
                            this.setState({
                                displayErrDlg: true,
                            });
                        } else if (audioData === null && lastFlg && noAudioErrs.length === 0) { // 最後の行：audioファイル名がない場合、一括登録成功ダイアログを出す
                            this.onSuccess();
                        } else if (audioData === null && !lastFlg) { // 最後の行ではなく、audioファイルがない場合、スキップする
                            this.stopLoading();
                        }
                    },
                });
            };
        } else {
            let message = [];
            for (let key in syserr) {
                message.push(
                    <div key={key}>
                        {syserr[key]}
                    </div>
                )
            }
            let syserrMessage;
            if (message.length > 0) {
                syserrMessage = PopupMessage({
                    type: POPUP_TYPE.SYS_ERROR,
                    message: message
                });
            }
            this.refToast.current.set(0, [
                syserrMessage,
            ]);
        };
    }


    // audioファイルを登録する
    saveAudioData = (response, audioName, audioData, lastFlg) => {
        const noAudioErrs = this.state.noAudioErrs;
        return new Promise((resolve, reject) => {
            try {
                let mode;
                if (this.props.editType === EDIT_TYPE.CHUNK) {
                    mode = 2;
                } else {
                    mode = 1;
                }
                if (lastFlg && noAudioErrs.length > 0) { // 最後の行：登録されていないaudioファイルがある場合
                    this.props.dispatch({
                        type: "UploadAudio_Saga",
                        id: response,
                        subjectID: this.state.subjectID,
                        mode: mode,
                        name: audioName,
                        audio: audioData,
                        onSuccess: () => {
                            this.stopLoading();
                            this.setState({
                                displayErrDlg: true,
                            });
                        },
                        onFailure: reject,
                    });
                } else if (lastFlg && noAudioErrs.length === 0) { // 最後の行：audioファイルが全て存在する場合
                    this.props.dispatch({
                        type: "UploadAudio_Saga",
                        id: response,
                        subjectID: this.state.subjectID,
                        mode: mode,
                        name: audioName,
                        audio: audioData,
                        onSuccess: this.onSuccess,
                        onFailure: reject,
                    });
                } else if (!lastFlg && audioData) { // 最後の行ではない場合
                    this.props.dispatch({
                        type: "UploadAudio_Saga",
                        id: response,
                        subjectID: this.state.subjectID,
                        mode: mode,
                        name: audioName,
                        audio: audioData,
                        onSuccess: resolve,
                        onFailure: reject,
                    });
                } else if (audioData === null) {
                    reject();
                }
            } catch(error) {
                reject(error);
            }
        });
    }

    // 保存成功時
    onSuccess = () => {
        this.setState({
            errType: null,
            textEn: null,
            textJp: null,
        })
        this.props.dispatch({
            type: "LoadEnd",
            message:
                PopupMessage({
                    type: POPUP_TYPE.SYS_INFO,
                    message: "教材情報が正常に保存されました"
                }),
            state: 1,
        });
        this.props.onClickSave(this.props.editType);
    }

    // 失敗時
    onFailure = () => {
        this.setState({
            errType: null,
            textEn: null,
            textJp: null,
        })
        this.props.dispatch({
            type: "LoadEnd"
        });
        this.props.onClickCancel();
    }

    // ローディング停止
    stopLoading = () => {
        this.setState({
            textEn: null,
            textJp: null,
        })
        this.props.dispatch({
            type: "LoadEnd"
        });
    }

    onClickErrDlg = () => {
        this.setState({
            displayErrDlg: false,
            errType: null,
            noFileErrs: [],
            noAudioErrs: [],
        })
        this.props.onClickSave(this.props.editType);
    }

    // エラーダイアログ
    displayErrDlgProps = () => {
        const errTitle = '入力ファイルにエラーがあります';
        const errType = this.state.errType;
        const noFileErrs = this.state.noFileErrs;
        const noAudioErrs = this.state.noAudioErrs;
        const displayErrDlg = this.state.displayErrDlg;
        // 必須ファイル・フォルダが存在しない場合のエラーメッセージ
        const noFileErrMsg = (errTitle, noFileErrs) => (
            <div style={{ color: "#ff0000" }}>
                <h3>{errTitle}</h3>
                <ul style={{ textAlign: "left" }} >
                    {noFileErrs.map((err, index) => (
                        <li key={index}>{err}が存在しませんでした</li>
                    ))}
                </ul>
            </div>
        )
        // 対象オーディオファイルが存在しない場合のエラーメッセージ
        const noAudioErrMsg = (errTitle, noAudioErrs) => (
            <div style={{ color: "#ff0000" }}>
                <h3>{errTitle}</h3>
                <p>指定のaudioファイルが存在しなかったため、<br /> 音声ファイルは未設定です</p>
                <ul style={{ textAlign: "left" }}>
                    {noAudioErrs.map((err, index) => (
                        <li  key={index}>（英語）{err.errTextEn}<br />（音声ファイル名）{err.errAudioName}</li>
                    ))}
                </ul>
            </div>
        )
        // データ取得件数が0件の場合
        const zeroDataErrMsg = (errTitle) => (
            <div style={{ color: "#ff0000" }}>
                <h3>{errTitle}</h3>
                <p>対象データが0件でした</p>
            </div>
        );
        // データ取得件数が100件より多い場合
        const overDataErrMsg = (errTitle) => (
            <div style={{ color: "#ff0000" }}>
                <h3>{errTitle}</h3>
                <p>対象データが制限件数をオーバーしています<br />(MAX100件)</p>
            </div>
        );
        // エラータイプに応じたエラーメッセージを表示
        if (errType === ERROR_ADD_ALL.NO_FILE) {
            const noFileErrContents = noFileErrMsg(errTitle, noFileErrs);
            return {
                display: displayErrDlg,
                contents: noFileErrContents,
                controls: {
                    'OK': {
                        Color: '#000',
                        onClick: this.onClickErrDlg,
                    },
                },
            }
        } else if (errType === ERROR_ADD_ALL.NO_AUDIO) {
            const noAudioErrContents = noAudioErrMsg(errTitle, noAudioErrs);
            return {
                display: displayErrDlg,
                contents: noAudioErrContents,
                controls: {
                    'OK': {
                        Color: '#000',
                        onClick: this.onClickErrDlg,
                    },
                },
            }
        } else if (errType === ERROR_ADD_ALL.ZERO_DATA) {
            const zeroDataErrContents = zeroDataErrMsg(errTitle);
            return {
                display: displayErrDlg,
                contents: zeroDataErrContents,
                controls: {
                    'OK': {
                        Color: '#000',
                        onClick: this.onClickErrDlg,
                    },
                },
            }
        } else if (errType === ERROR_ADD_ALL.OVER_DATA) {
            const overDataErrContents = overDataErrMsg(errTitle);
            return {
                display: displayErrDlg,
                contents: overDataErrContents,
                controls: {
                    'OK': {
                        Color: '#000',
                        onClick: this.onClickErrDlg,
                    },
                },
            }
        } else {
            return {
                display: false,
                contents: "",
                controls: {
                    'OK': {
                        Color: '#000',
                        onClick: this.onClickErrDlg,
                    },
                },
            }
        }
    }

    render() {
        let title = "";
        if (this.props.editType === EDIT_TYPE.CHUNK) {
            title = "チャンク";
        } else {
            title = "ボキャブラリー";
        }
        const propsToast = {
            timeout: 2000,
            bottom: "55px",
            right: "20px",
        };
        const propsErrDlg = this.displayErrDlgProps();
        return (
            <Body name="phrase-add-all" Display={this.props.display}>
                <Back Display={this.props.display}></Back>
                <Dialog Display={this.props.display}>
                    <ContentsWrap>
                        <Contents>
                            <Header>{title + "の一括登録"}</Header>
                            <Column>
                                <Title>
                                    一括登録データZipファイル
                                </Title>
                                <Edit>
                                    <input ref={this.refZipFileInput} type="file" style={{ width: 0, padding: 0, visibility: "hidden" }} onChange={this.onChangeFile} />
                                    <FileButton onClick={this.onClickFileUpload}>アップロード</FileButton>
                                    {this.state.zipFile && this.state.zipFileName}
                                </Edit>
                            </Column>
                        </Contents>
                    </ContentsWrap>
                    <Controls>
                        <Button
                            Color="#0077FF"
                            Width="100px"
                            onClick={this.onClickAddAll}
                            text="一括登録" />
                        <Button
                            Color="#888888"
                            Width="100px"
                            onClick={this.props.onClickCancel}
                            text="キャンセル" />
                    </Controls>
                </Dialog>
                <Toast ref={this.refToast} {...propsToast} />
                <ModalDialog key="uniqueKey" name="errDialog" {...propsErrDlg} />
            </Body>
        );
    }
}

export { PhraseAddAllModal };

const Body = styled.div`
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    pointer-events: ${props => (props.Display ? '' : 'none')};
`;

const Back = styled.div`
    position: absolute;
    top: 0;
    left: 0;

    background-color: #000;
    opacity: ${props => (props.Display ? '0.2' : '0')};
    transition-duration: 0.2s;

    width: 100%;
    height: 100%;
`;

const Dialog = styled.div`
    position: absolute;
    top: ${props => (props.Display ? '50%' : '47%')};
    left: 50%;
    transform: translate(-50%, -50%);

    background-color: #fff;
    opacity: ${props => (props.Display ? '1' : '0')};
    text-align: center;
    transition-duration: 0.2s;
    border-radius: 5px;
    z-index: 2;
`;

const ContentsWrap = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    font-size: 14px;
`;
const Contents = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    position: relative;
`;

const Header = styled.div`
    color: #888;
    font-size: 18px;
    text-align: center;
    width: 100%;
    margin-bottom: 10px;
    font-weight: bold;
`;

const Column = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    margin: 2px 0;
`;
const Title = styled.div`
    background-color: #888;
    color: #fff;
    width: 200px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
`;
const Edit = styled.div`
    min-width: 150px;
    min-height: 30px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid #888;
    margin-right: 10px;
    max-width: 490px;
    width: 490px;

    input {
        border-radius: 0;
        border: none;
        color: #888;
    }
`;

const Controls = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
`;
const FileButton = styled.div`
    background-color: #efefef;
    color: #888;
    padding: 2px 10px;
    cursor: pointer;
    margin-right: 10px;
`;
const EDIT_TYPE = {
    VOCABULARY: 0,
    CHUNK: 1,
};
const ERROR_ADD_ALL = {
    NO_FILE: 1,
    NO_AUDIO: 2,
    ZERO_DATA: 3,
    OVER_DATA: 4,
};